import { CORE_AXIOS, type Http } from "@/core"
import { container } from "tsyringe"
import type { AddressModel, AddressSite } from "./interface/AddressInterface"

/** GET address info list */
export async function addressGetAll(): Promise<{ addresses: AddressModel[] }> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get('/v1/api/ums/addresses')
}

/** GET location city */
export async function addressGetLocation(code?: string): Promise<{ divisions: AddressSite[] }> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  const codeString = code == undefined ? '' : `/${code}`
  return axios.get('/v1/api/system/sub_administrative_divisions' + codeString)
}

/** ADD address info */
export async function addressAdd(data: AddressModel): Promise<AddressModel> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.post('/v1/api/ums/addresses', data)
}

/** UPDATE address info */
export async function addressUpdate(data: AddressModel): Promise<AddressModel> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.put('/v1/api/ums/addresses/' + data.id, data)
}

/** DELETE address info */
export async function addressDelete(data: AddressModel): Promise<AddressModel> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.delete('/v1/api/ums/addresses/' + data.id)
}

